module.exports = __webpack_public_path__ + "static/scenario2-68e90adacde2c6b55b28ef50113cec1a.png";